import React from "react";
import type { SearchProviderValue } from "./dto";
/**
 * 上下文
 */
export const SearchGroupContext = React.createContext<SearchProviderValue<any>>(
  {
    query: {},
    dispatch: () => {},
    submit: () => {},
    reset: () => {},
    refresh: () => {},
  }
);
